<script setup lang="ts">
import { ref } from 'vue';
import { useLocale } from '../../../composables/useLocale';
import useModal, { ModalTypes } from '../../../composables/useModal';
import { Filters as FilterType } from '../types';

import Filters from './Filters.vue';
import Modal from '../../../el/Modal.vue';

const { t } = useLocale();

const props = defineProps<{
  name: ModalTypes;
  isLoading: boolean;
  filters: FilterType;
}>();

const { isOpen } = useModal(props.name);
const filtersRef = ref<InstanceType<typeof Filters>>();
</script>

<template>
  <Modal
    :name="name"
    :title="t('lcp.filters')"
    title-prepend-icon="mdi-filter-variant"
    :is-open="isOpen"
    :loading="isLoading"
    :action="filtersRef?.applyFilters"
    :action-label="t('lcp.filters-apply')"
    :action-disabled="!filtersRef?.filtersChanged"
    :cancel-action="filtersRef?.clearAllFilters"
    :cancel-action-label="t('lcp.filters-clear')"
    :cancel-disabled="filtersRef?.filtersEmpty"
    cancel-action-variant="flat"
    cancel-action-color="rgba(var(--v-theme-error-container))"
    :secondary-action="filtersRef?.isResetFiltersEnabled ? filtersRef?.resetFilters : undefined"
    :secondary-action-disabled="filtersRef?.filtersWithOnlyDefaults"
    :secondary-action-label="t('lcp.filters-reset')"
    secondary-action-variant="flat"
    secondary-action-color="rgba(var(--v-theme-error-container))"
  >
    <Filters ref="filtersRef" :filters="filters"></Filters>
  </Modal>
</template>
